import fectx from 'helper/fectx';
import { parseQueryString } from 'utils/url';

const queryStr = parseQueryString(window.location.search);

export default function statistic(type, params = {}, code = queryStr.actcode) {
  if (process.env.NODE_ENV === 'development') {
    console.log(`statistic code: ${code} type: ${type}`);
    return;
  }

  const query = {
    ...params,
    type,
  };
  setTimeout(() => {
    fectx.post(`/act/${code}/WeChatReport`, query);
  }, 0);
}
